import { useState } from 'react';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import useAuth from '../../../hooks/useAuth';
import { createPropertyEndpoint } from '../services/propertyService';

interface CreateResult {
  status: number;
  error?: any;
  request?: any;
  response?: any;
}

const useCreatePropertyOperation = () => {
  const { getAuthToken } = useAuth();
  const token = getAuthToken();
  const { callEndpoint } = useCallApiAndLoad();
  const [loading, setLoading] = useState(false);

  const createProperty = async (fields: any): Promise<CreateResult> => {
    setLoading(true);
    try {
      const { status, data } = await callEndpoint(
        createPropertyEndpoint(fields, token)
      );
      setLoading(false);
      return {
        status,
        error: status !== 200 && status !== 201 ? data : undefined,
        request: fields,
        response: data,
      };
    } catch (error) {
      setLoading(false);
      return {
        status: 500,
        error,
        request: fields,
        response: undefined,
      };
    }
  };

  return {
    createProperty,
    loading,
  };
};

export default useCreatePropertyOperation;